import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { STORE_NAME } from '../config'

const faqs = [
  {
    q: 'What is the minimum order quantity?',
    a: `At ${STORE_NAME}, MOQs vary by product and format. Retail lines can be ordered by the case, while bulk commodities typically start at pallet or container quantities. The exact MOQ is shown on every wholesale product card, and our trade desk can often find a workaround for unusual volume requirements.`
  },
  {
    q: 'Which regions do you ship to?',
    a: `At ${STORE_NAME}, we ship throughout Europe and arrange export to Africa, the Middle East and Asia through our freight partners. Destination-specific lead times, customs requirements and documentation are included in every quote we send — no hidden surprises at the border.`
  },
  {
    q: 'What documentation comes with a shipment?',
    a: `Every ${STORE_NAME} shipment includes certificates of analysis, origin and phytosanitary certificates where applicable, plus Halal, Kosher or organic certificates on supported lines. Our compliance team confirms all documents before the shipment leaves origin.`
  },
  {
    q: 'What are your payment terms?',
    a: `New ${STORE_NAME} accounts typically start on pro-forma payment (TT). Established wholesale partners can move to letters of credit or agreed credit terms once a trading history is built. Our team will walk you through the options on your first order.`
  },
  {
    q: 'How long does delivery take?',
    a: `In-stock retail items dispatch within days. Bulk and containerised orders through ${STORE_NAME} typically land in 2–6 weeks depending on origin, routing and customs clearance at destination — your quote always states a confirmed delivery window.`
  },
  {
    q: 'Do you support private label?',
    a: `Yes — at ${STORE_NAME}, we arrange private-label packaging, labelling and compliance review on select lines. Send your brand requirements through the inquiry or contact form and our team will scope feasibility, cost and lead time.`
  }
]

export function Faq() {
  const [open, setOpen] = useState(0)

  return (
    <section className="bg-brand-shell px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-navy">
          Need to know
        </span>
        <h2 className="heading-accent font-display text-2xl font-bold text-brand-ink sm:text-3xl">
          Frequently asked questions
        </h2>
        <p className="mt-4 max-w-2xl text-brand-slate">
          The questions our trade desk at {STORE_NAME} answers most often — for anything else, contact us directly.
        </p>
        <div className="mt-10 divide-y divide-brand-slate/10 rounded-2xl bg-white shadow-card">
          {faqs.map((f, i) => {
            const isOpen = open === i
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-semibold text-brand-ink">{f.q}</span>
                  <ChevronDown
                    className={`h-5 w-5 shrink-0 text-brand-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isOpen && (
                  <p className="px-6 pb-5 text-sm leading-relaxed text-brand-slate">{f.a}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
